import React from 'react';

/**
 * An on/off switch: a visually hidden checkbox, announced as a switch, inside its label.
 * `describedBy` names the hint, or the reason it is `disabled`.
 */
const Toggle = ({
  checked,
  onChange,
  label,
  className = '',
  labelPosition = 'left', // 'left' or 'right'
  disabled = false,
  describedBy,
}) => {
  return (
    <label className={`flex items-center ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${className}`}>
      {labelPosition === 'left' && label && (
        <span className="mr-2 text-sm text-gray-700 dark:text-gray-300">{label}</span>
      )}

      <div className="relative shrink-0">
        <input
          type="checkbox"
          role="switch"
          className="sr-only peer"
          checked={checked}
          disabled={disabled}
          aria-describedby={describedBy}
          onChange={onChange}
        />
        {/* The input is visually hidden: its keyboard focus shows as a ring on the track. */}
        <div className={`block w-10 h-6 rounded-full transition peer-focus-visible:ring-2 peer-focus-visible:ring-blue-500 peer-focus-visible:ring-offset-2 dark:peer-focus-visible:ring-offset-gray-900 ${checked ? 'bg-blue-500' : 'bg-gray-500 dark:bg-gray-400'}`}></div>
        <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${checked ? 'transform translate-x-4' : ''}`}></div>
      </div>

      {labelPosition === 'right' && label && (
        <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">{label}</span>
      )}
    </label>
  );
};

export default Toggle;
